import React from 'react';
import cn from 'classnames';
import centralLogo from 'src/assets/header-logo.svg';

import { ProgressLine } from '../ProgressLine';
import css from './Preloader.module.scss';

interface Props {
  className?: string;
  visible: boolean;
}

export default function Preloader({ visible, className = '' }: Props) {
  return (
    <div className={cn(css.preloaderWrapper, css[className])}>
      <div className={css.loaderContent}>
        <img src={centralLogo} alt="" />
        <p>מחשב תוצאות...</p>
        <ProgressLine percentNumber={100} />
      </div>
    </div>
  );
}
